import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
/**
 * Container for Google AdSense Units. This component is NOT themeable; please add any necessary styling through the `style` or `className` prop.
 *
 * In order to use this component, you must first have your site added and an ad created with Google AdSense for your product. From there, you can find the autogenerated AdSense code, which will help you understand which props you'll want to pass in.
 *
 * You'll also need to have the proper AdSense scripts added to the `head` or `body` of your codebase to assure that this works. These scripts will be provided to you from AdSense once you add your site.
 *
 * For local testing, you will not be able to see your ads populated. They will only be visible in production.
 *
 * ```js
 * import { AdSenseUnit } from '@minerva-analytics/pantheon';
 *
 * <AdSenseUnit
 *   slot='123456'
 *   style={{ display: `block`, height: `250px`, width: `300px` }}
 * />
 * ```
 */

export var AdSenseUnit = function AdSenseUnit(props, _ref) {
  var rest = _extends({}, _ref);

  useEffect(function () {
    if (window) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);
  return /*#__PURE__*/React.createElement("ins", _extends({
    className: props.className ? props.className + " adsbygoogle" : "adsbygoogle",
    style: props.style,
    "data-ad-test": process.env.API_ENV && process.env.NODE_ENV ? "off" : "on",
    "data-ad-client": props.client || "ca-pub-9379146346152432",
    "data-ad-slot": props.slot,
    "data-ad-format": props.format,
    "data-ad-layout": props.layout,
    "data-ad-layout-key": props.layoutKey,
    "data-full-width-responsive": props.responsive
  }, rest));
};
AdSenseUnit.propTypes = {
  /** Custom className for the ad. Defaults to `adsbygoogle`. */
  className: PropTypes.string,

  /** Unique ad client. Defaults to `ca-pub-9379146346152432`. Denoted in AdSense code as `data-ad-client`. */
  client: PropTypes.string,

  /** Unique Ad unit ID. Denoted in AdSense code as `data-ad-slot` */
  slot: PropTypes.string.isRequired,

  /** Specific shape for the ad. Denoted in AdSense code as `data-ad-format`. Set to auto by default. */
  format: PropTypes.string,

  /** Custom styles for the ad */
  style: PropTypes.object,

  /** Ad layout. Denoted in AdSense code as `data-ad-layout`. */
  layout: PropTypes.string,

  /** Autogenerated key for ad layout. Denoted in AdSense code as `data-ad-layout-key`. */
  layoutKey: PropTypes.string,

  /** Determines whether the ad is responsive or not. If your ad is responsive, you'll want to pass in a string such as "true". Denoted in AdSense code as `data-full-width-responsive`. */
  responsive: PropTypes.string
};
export default AdSenseUnit;